import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './CloseSticky.scss';

const CloseSticky = ({ timeout, closeMiniTvWidget }) => {
  const [seconds, setSeconds] = useState(timeout);

  useEffect(
    () => {
      let timer;
      if (seconds > 0) {
        timer = setTimeout(() => {
          setSeconds(prevSeconds => prevSeconds - 1);
        }, 1000);
      }
      return () => clearTimeout(timer);
    },
    [seconds],
  );

  const updateStickyClass = type => {
    try {
      document.querySelector('body').classList[type]('stick_minitv_top');
    } catch (error) {
      //
    }
  };

  useEffect(() => {
    updateStickyClass('add');
    return () => updateStickyClass('remove');
  }, []);
  return (
    <div className={s.autoClose}>
      {seconds ? (
        <span className={s.autoCloseTimer}>
          <span className={s.grayBorder}>
            <span className={s.timer}>{seconds}</span>
          </span>
          <span className={s.colorBorder} />
        </span>
      ) : (
        <span className={s.closeBtn} onClick={() => closeMiniTvWidget()} />
      )}
    </div>
  );
};
CloseSticky.propTypes = {
  timeout: PropTypes.number,
  closeMiniTvWidget: PropTypes.func.isRequired,
};
CloseSticky.defaultProps = {
  timeout: 10,
};
export default CloseSticky;
